import React, { useContext } from 'react'
import moment from 'moment'
import { displayEventLocation } from '../../../../../helpers/eventAddress'
import DetailsBox, {
  DetailRow,
} from '../../../../../components/Cards/DetailsBox'
import { Link } from 'react-router-dom'
import { EventMetaContext, OpsPlanContext } from '../../SingleEvent'
//@MUI
import IconButton from '@mui/material/IconButton'
import EditIcon from '@mui/icons-material/Edit'

const EventInformation = () => {
  const { setEditMode, eventMeta } = useContext(EventMetaContext)
  const { opsPlan } = useContext(OpsPlanContext)

  return (
    <DetailsBox
      title="Event Information"
      buttonRight={
        <IconButton onClick={() => setEditMode(true)}>
          <EditIcon />
        </IconButton>
      }
      rows={[
        {
          label: 'Start',
          value: moment(eventMeta.startDate).format('Do MMM YYYY - HH:mm'),
        },
        {
          label: 'End',
          value: moment(eventMeta.endDate).format('Do MMM YYYY - HH:mm'),
        },
        {
          label: 'Organiser',
          value: (
            <Link
              style={{ color: '#181818' }}
              to={`/clients/${eventMeta.organisation?._id}`}
            >
              {eventMeta.organisation?.orgName}
            </Link>
          ),
        },
        {
          label: 'Event Type',
          value: eventMeta.eventType,
        },
        {
          label: 'Event Location',
          value: displayEventLocation(eventMeta),
        },
        { label: 'What3Words', value: opsPlan?.what3Words },
        {
          label: 'Created By',
          value:
            eventMeta?.eventCreatedBy &&
            `${eventMeta?.eventCreatedBy?.firstName} ${
              eventMeta?.eventCreatedBy?.lastName
            } - ${moment(eventMeta.createdAt).format('Do MMM YYYY HH:mm')}`,
          avatar: eventMeta?.eventCreatedBy?.photograph,
        },
        {
          label: 'Updated By',
          value:
            eventMeta?.eventUpdatedBy &&
            `${eventMeta?.eventUpdatedBy?.firstName} ${
              eventMeta?.eventUpdatedBy?.lastName
            } - ${moment(eventMeta.updatedAt).format('Do MMM YYYY HH:mm')}`,
          avatar: eventMeta?.eventUpdatedBy?.photograph,
        },
      ]}
    >
      {eventMeta.status === 'Cancelled' && (
        <DetailRow
          label="Cancellation Reason"
          value={eventMeta.cancellationReason}
        />
      )}
    </DetailsBox>
  )
}

export default React.memo(EventInformation)
